import * as pc from 'playcanvas';

class PlayCanvasTextureRenderer {
    constructor(canvasId, planeSelector = '#myPlane') {
        // 1. Create or get the canvas
        if (!canvasId) {
            this.canvas = document.createElement('canvas');
            this.canvas.id = 'playcanvas-canvas';
            document.body.appendChild(this.canvas);
        } else {
            this.canvas = document.getElementById(canvasId);
        }
        
        // 2. Set canvas to desired size and hide it
        this.canvas.width = 1024;
        this.canvas.height = 1024;
        this.canvas.style.display = 'none';

        // 3. Create a PlayCanvas Application
        const config = {
            canvas: this.canvas,
            mouse: new pc.Mouse(this.canvas),
            keyboard: new pc.Keyboard(window),
            graphicsDeviceOptions: { alpha: true }
        };
        this.app = new pc.Application(this.canvas, config);
        this.app.setCanvasResolution(pc.RESOLUTION_AUTO);
        this.app.setCanvasFillMode(pc.FILLMODE_NONE);
        this.app.graphicsDevice.maxPixelRatio = window.devicePixelRatio;
        this.app.start();

        // 4. Setup a simple test scene
        this._createTestScene();

        // 5. Grab the a-plane you want to update directly
        this.aframePlane = document.querySelector(planeSelector);
        if (!this.aframePlane) {
            console.error('No A-Frame plane found with selector:', planeSelector);
            return;
        }
        
        // 6. Listen for window resizing
        window.addEventListener('resize', () => {
            this.app.resizeCanvas();
        });

        // 7. Start the update loop
        this._startLoop();
    }

    _createTestScene() {
        // Simple box
        const box = new pc.Entity('box');
        box.addComponent('render', { type: 'box' });
        box.setPosition(0, 0, -3);
        this.app.root.addChild(box);

        // Red material
        const material = new pc.StandardMaterial();
        material.diffuse = new pc.Color(1, 0, 0);
        material.update();
        box.render.material = material;

        // Spin the box
        this.app.on('update', (dt) => {
            box.rotate(10 * dt, 20 * dt, 30 * dt);
        });

        // Camera
        this.camera = new pc.Entity('camera');
        this.camera.addComponent('camera', {
            clearColor: new pc.Color(0.2, 0.2, 0.2, 1),
            farClip: 1000,
            nearClip: 0.1
        });
        this.app.root.addChild(this.camera);
        this.camera.setPosition(0, 0, 5);
        this.camera.lookAt(0, 0, 0);

        // Light
        const light = new pc.Entity('light');
        light.addComponent('light', {
            type: 'directional',
            color: new pc.Color(1, 1, 1),
            castShadows: true
        });
        light.setEulerAngles(45, 30, 0);
        this.app.root.addChild(light);
    }

    _startLoop() {
        this.app.on('update', (dt) => this._update(dt));
    }

    _update(dt) {
        // 1. Render the scene in PlayCanvas
        this.app.render();

        // 2. Convert canvas to data URL
        const dataUrl = this.canvas.toDataURL('image/png');
        const hiddenImage = document.getElementById('playcanvasImage');
        hiddenImage.src = dataUrl;
        // 3. Directly update the plane’s material with the data URL
        //    “shader: flat” in A-Frame is often best for unlit textures
        /*this.aframePlane.setAttribute('material', {
            src: dataUrl,
            side: 'double',
            shader: 'flat',
            transparent: true
        });*/
    }

    destroy() {
        if (this.app) {
            this.app.destroy();
        }
        if (this.canvas && this.canvas.parentNode) {
            this.canvas.parentNode.removeChild(this.canvas);
        }
    }
}

export default PlayCanvasTextureRenderer;
